import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import DropdownMenu, { DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { AD_CONTROL_DROP_DOWN_MENU_CLOSED, AD_CONTROL_DROP_DOWN_MENU_OPENED } from '../../common/constants';
import { useACTAnalyticsEvents } from '../../common/utils';
import { useAdControlProvider } from '../../controllers';
const interactedUIEventAction = {
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'adControlsDropdown'
};
const AdControlDropdownMenu = ({
  children,
  itemId,
  onOpenChange = () => {},
  ...rest
}) => {
  const {
    createInteractedUIEvent
  } = useACTAnalyticsEvents();
  const {
    createEventDispatcher
  } = useAdControlProvider();
  const eventDispatcher = React.useMemo(() => createEventDispatcher(itemId), [createEventDispatcher, itemId]);
  return /*#__PURE__*/React.createElement(DropdownMenu, _extends({}, rest, {
    onOpenChange: onOpenChangeArgs => {
      eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? AD_CONTROL_DROP_DOWN_MENU_OPENED : AD_CONTROL_DROP_DOWN_MENU_CLOSED, createInteractedUIEvent(interactedUIEventAction));
      onOpenChange(onOpenChangeArgs);
    }
  }), /*#__PURE__*/React.createElement(DropdownItemGroup, null, typeof children === 'function' ? children({
    itemId
  }) : children));
};
export default AdControlDropdownMenu;